var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeat6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9738 0.926759C24.4631 0.415038 25.2562 0.415039 25.7455 0.92676L41.5179 17.4244C42.0071 17.9361 42.0071 18.7658 41.5179 19.2775L37.9501 23.0093C37.4609 23.521 36.6676 23.521 36.1784 23.0093L20.406 6.51175C19.9168 6.00003 19.9168 5.17037 20.406 4.65864L23.9738 0.926759Z",
    fill: "#5ED3F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9033 17.8383C42.3926 18.35 42.3926 19.1797 41.9033 19.6914L25.7874 36.5482C25.2982 37.0599 24.5051 37.0599 24.0158 36.5482L20.448 32.8163C19.9588 32.3046 19.9588 31.4749 20.448 30.9632L36.5638 14.1064C37.053 13.5947 37.8462 13.5947 38.3354 14.1064L41.9033 17.8383Z",
    fill: "#5ED3F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45821 0.926759C4.94743 0.415038 5.74063 0.415039 6.22985 0.92676L22.0023 17.4244C22.4915 17.9361 22.4915 18.7658 22.0023 19.2775L18.4345 23.0093C17.9453 23.521 17.152 23.521 16.6628 23.0093L0.890359 6.51175C0.401131 6.00003 0.40113 5.17037 0.890359 4.65864L4.45821 0.926759Z",
    fill: "#5ED3F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3877 17.8383C22.8769 18.35 22.8769 19.1797 22.3877 19.6914L6.27185 36.5482C5.78262 37.0599 4.98943 37.0599 4.50019 36.5482L0.932351 32.8163C0.443122 32.3046 0.443123 31.4749 0.932351 30.9632L17.0482 14.1064C17.5374 13.5947 18.3306 13.5947 18.8198 14.1064L22.3877 17.8383Z",
    fill: "#5ED3F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat6);
export default __webpack_public_path__ + "static/media/feat-6.e0b88a22f1f1a7bc2e8d6cdf40659158.svg";
export { ForwardRef as ReactComponent };